import styled from 'styled-components';

export const CustomForm = styled.form``;

export const FormText = styled.p`
  font-size: 18px;
  font-weight: 400;
  margin-top: 20px;
`;
